export const SortParamEnum = {
    ASC: 'asc',
    DESC: 'desc',
} as const;

export type SortParamType = (typeof SortParamEnum)[keyof typeof SortParamEnum];
